"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPropertyReducer(_reducer, property) {
    return typeof property !== 'undefined';
}
exports.default = isPropertyReducer;
;
